import API from '../../../../../services/api';

export const API_NOTIFICACIONES = {
    getNotificaciones: async (tipo, page) => {
        return await API.get(`/notificaciones?tipo=${tipo}&page=${page}`).then(res => res.data);
    },
    getRecordatorios: async () => {
        return await API.get('/recordatorios').then(res => res.data);
    },
    archivarNotificacion: async (notificacion, archived) => {
        return await API.put('/notificaciones/' + notificacion.id, {archivado: archived}).then(res => res.data);
    },
    archivarAllNotificaciones: async () => {
        return await API.post('/notificaciones/archivar', { type: 'all' }).then(res => res.data);
    }
}